/* Kedgo! · FVN · Barra fija de la ficha desde el inicio en el celular (2026-10-04, hallazgo E-01; Esteban: «barra fija
   desde el inicio»). La barra nativa (hdt-sticky-btn-atc) solo sale cuando TODO el formulario queda arriba de la
   pantalla; en el celular el botón «Agregar al carrito» queda debajo de la galería y la barra no salía al abrir la ficha.
   Aquí se muestra mientras el BOTÓN no esté a la vista, y se esconde al llegar al pie de página. Usa su propia clase en
   el body (kdg-barra-ficha) para no pelear con la del tema (sticky-shown).
   La barra muestra la talla elegida («$29.900 · Talla 21-22»): con la barra visible desde el inicio, quien toca
   «Agregar» sin bajar debe ver qué talla se va al carrito (el tema deja una preseleccionada). */
(function () {
  if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;
  var barra = document.querySelector('hdt-sticky-btn-atc');
  if (!barra || !('IntersectionObserver' in window)) return;
  var form = document.forms[barra.getAttribute('form')];
  var boton = form && form.querySelector('[name="add"]');
  if (!boton) return;
  var pie = document.querySelector('footer');
  var botonVisible = true, pieVisible = false;
  var io = new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      if (e.target === boton) botonVisible = e.isIntersecting;
      if (e.target === pie) pieVisible = e.isIntersecting;
    });
    document.body.classList.toggle('kdg-barra-ficha', !botonVisible && !pieVisible);
  });
  io.observe(boton);

  // talla elegida dentro de la barra
  var info = barra.querySelector('.hdt-sticky-atc__infos-content .hdt-sticky-atc__infos');
  var campo = document.querySelector('.hdt-product-info__list fieldset.is-style-size');
  if (info && campo) {
    var etiqueta = document.createElement('span');
    etiqueta.className = 'kdg-barra-talla';
    info.appendChild(etiqueta);
    var talla = function () {
      var r = campo.querySelector('input:checked');
      var KT = window.kdgT || {};
      etiqueta.textContent = r ? (KT.talla || 'Talla') + ' ' + r.value : (KT.elige || 'Elige tu talla');
    };
    campo.addEventListener('change', function () { setTimeout(talla, 30); });
    talla();
  }
  if (pie) io.observe(pie);
})();
